// filepath: apps/web/src/features/directory/audit-history/AuditHistoryRoute.tsx
//
// FR-UI-DIR-1 AC-10 — route shell for /audit (directory audit feed).

import { AuditHistoryPage } from "./AuditHistoryPage";

export function AuditHistoryRoute(): React.ReactElement {
  return <AuditHistoryPage />;
}
